var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen overflow-hidden"},[_c('Header'),_c('main',{staticClass:"flex-grow"},[_c('ContentSingle')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }